import TablePage from '@/components/pages/Organization/Table/Table'
import TableSummary from '@/components/pages/Organization/Table/Summary'
import EditAppointmentPage from '@/components/pages/Organization/Table/EditAppointment'
import CategoriesPage from '@/components/pages/Organization/Customers/Categories/Categories'
import CustomersLayout from '@/components/pages/Organization/Customers/Layout'
import CustomersPage from '@/components/pages/Organization/Customers/Customers'
import CustomerPage from '@/components/pages/Organization/Customers/Customer'
import StatsPage from '@/components/pages/Organization/Stats/Stats'
import OrganizationStats from '@/components/pages/Organization/Stats/OrganizationStats'
import EmployeeStats from '@/components/pages/Organization/Stats/EmployeeStats'
import SettingsPage from '@/components/pages/Organization/Settings/Settings'
import ProfilePage from '@/components/pages/Organization/Settings/Profile'
import EmployeesPage from '@/components/pages/Organization/Settings/Employees/Employees'
import ServicesPage from '@/components/pages/Organization/Settings/Services/Services'
import MaterialsPage from '@/components/pages/Organization/Settings/Materials/Materials'
import AccountPage from '@/components/pages/Organization/Settings/Account'

import auth from '@/auth'

export default [
  {
    path: '/',
    redirect: to => {
      return 'table'
    }
  },
  {
    path: 'table/summary/:date?',
    component: TableSummary,
    name: 'summary'
  },
  {
    path: 'table/:date?',
    component: TablePage,
    name: 'table'
  },
  {
    path: 'appointment/:appointment',
    component: EditAppointmentPage,
    name: 'edit'
  },
  {
    path: 'customers',
    component: CustomersLayout,
    meta: {roles: ['owner', 'manager', 'employee']},
    children: [
      {
        path: '/',
        component: CustomersPage
      },
      {
        path: 'categories',
        component: CategoriesPage
      },
      {
        path: 'show/:customer',
        component: CustomerPage
      }
    ]
  },
  {
    path: 'stats',
    component: StatsPage,
    meta: {roles: ['owner', 'manager']},
    children: [
      {
        path: '/',
        component: OrganizationStats
      },
      {
        path: 'employee/:employee',
        component: EmployeeStats
      }
    ]
  },
  {
    path: 'settings',
    component: SettingsPage,
    children: [
      {
        path: '/',
        redirect: to => {
          if (auth.hasRoles(['owner', 'manager'])) {
            return 'profile'
          }

          return 'account'
        }
      },
      {
        path: 'profile',
        component: ProfilePage,
        meta: {roles: ['owner', 'manager']}
      },
      {
        path: 'employees',
        component: EmployeesPage,
        meta: {roles: ['owner', 'manager']}
      },
      {
        path: 'services',
        component: ServicesPage,
        meta: {roles: ['owner', 'manager']}
      },
      {
        path: 'materials',
        component: MaterialsPage,
        meta: {roles: ['owner', 'manager']}
      },
      {
        path: 'account',
        component: AccountPage
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/organizationRoutes.js